import React, { lazy, Suspense, useEffect, useState } from 'react';
import { seismicTheme, Theme } from '@seismic/mantle';
import { routes } from 'constants/config';
import request from 'utils/request_ajax';

const AsyncUVR = lazy(() =>
  import(
    /* webpackChunkName: "UVR" */ '@seismic/universal-video-recorder'
  ).then(module => ({ default: module.UniversalVideoRecorder })),
);

const UniversalRecorder = ({
  isOpen,
  handleComplete,
  handleOnInitialize,
  handleRecordingCancel,
  handleRecordingStart,
  handleRecordingStop,
  onUVRReady,
}) => {
  const [loading, setIsLoading] = useState(true);
  const [vfsUrl, setVfsUrl] = useState(null);
  const [recorderToken, setRecorderToken] = useState(null);

  useEffect(() => {
    const recorderTokenProm = request.get(routes.SEISMIC.RECORDER_TOKEN);
    const vfsProm = request.get(routes.SEISMIC.VIDEO_FOUNDATION_SERVICE);

    Promise.all([recorderTokenProm, vfsProm])
      .then(([token, vfs]) => {
        setRecorderToken(token.token);
        setVfsUrl(vfs.url);
        setIsLoading(false);
      })
      .catch(error => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    if (!loading) {
      if (typeof onUVRReady === 'function') {
        onUVRReady();
      }
    }
  }, [onUVRReady, loading]);

  const handleVideoSubmitted = eventData => {
    handleComplete(eventData?.storageId);
  };

  return (
    <Theme theme={seismicTheme({ useGlobal: true })}>
      {!loading && (
        <Suspense fallback={null}>
          <AsyncUVR
            open={isOpen}
            enableV2
            hideTitle
            onComplete={handleVideoSubmitted}
            onInitialize={handleOnInitialize}
            onRecordingCancel={handleRecordingCancel}
            onRecordingStart={handleRecordingStart}
            onRecordingStop={handleRecordingStop}
            vfsUrl={vfsUrl}
            getAuthToken={() => recorderToken}
            willFallbackToV1={false}
          />
        </Suspense>
      )}
    </Theme>
  );
};

export default UniversalRecorder;
